import React, { useMemo } from 'react'
import { isInternal } from 'helpers'
import { linearScale } from 'styled-system-scale'

import { Box, Flex, Text, Link } from 'system'
import { Heading } from './'

export const LinkCard = ({ href, title, children, ...props }) => {
  const hrefHost = useMemo(() => {
    const isString = typeof href === 'string'
    if (!isString) return ''

    const matches = href.match(/(?:[\w-]+\.)*[\w-]{1,63}(?:\.(?:\w*))/)
    if (!matches) return ''

    return matches.toString()
  }, [href])

  return (
    <Flex
      bg="purple.100"
      borderRadius={linearScale('4px', '8px', { count: 5 })}
      flexDirection="column"
      maxWidth={[null, '24rem']}
      myScale="m"
      pScale="m"
      {...props}
    >
      <Box flex="1 1 auto">
        <Heading as="h4" fontSizeScale="m" fontWeight="semibold">
          <Link
            href={href}
            transitionProperty="color"
            css={p => ({
              '&:hover,&:focus': { color: p.theme.colors.purple[50] },
            })}
          >
            {title}
          </Link>
        </Heading>
        {children && (
          <Text
            as="p"
            fontSizeScale="s"
            lineHeight="copyTight"
            mtScale="t-"
            color="slate.30"
          >
            {children}
          </Text>
        )}
      </Box>
      {!isInternal(href) && (
        <Link href={href} color="purple.50" mtScale="s">
          <Flex alignItems="center">
            <Text
              as="p"
              fontSizeScale="s"
              lineHeight="title"
              textAlign="right"
              mrScale="t+"
            >
              {hrefHost}
            </Text>
          </Flex>
        </Link>
      )}
    </Flex>
  )
}
